import {createSelector} from 'reselect';

export const getState = (state) => state.appState;

export const getViewMode = createSelector([getState], (appState) => appState.viewMode);
export const getErrorBoundary = createSelector([getState], (appState) => appState.errorBoundary);
export const getSoftwareVersion = createSelector([getState], (appState) => appState.version);
